import React from 'react'
import styled, { css } from 'styled-components'
import Dropdown from 'components/Dropdown'
import Caption from 'components/Caption'
import { breakpoint } from 'utils'
import { Truncate } from 'components/Truncate'
import { navbarTitleCss } from 'components/Navbar/Navbar'

export const WorkspaceName = styled(Truncate)`
  line-height: 1.5;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`

export const SelectedWorkspaceName = styled(WorkspaceName)`
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  ${breakpoint('base', 'xxs')`
    display: none;
  `}
`

export const DropdownContentContainer = styled.div`
  clip-path: inset(0px 0px 0px 0px round 12px);
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 320px;
  padding: 8px 0;
`

// Workspace selector trigger
export const DropdownTarget = styled.button.attrs({
  'data-testid': 'navbar-title',
})(
  ({ theme }) => css`
    ${navbarTitleCss};

    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border: 0;
    background: none;
    width: ${theme.sidebar.leftWidth}px;
    height: ${theme.header.height}px;
    outline-offset: -2px; /* To avoid cutting focus ring */

    ${WorkspaceName} {
      ${breakpoint('sm')`
        flex: 1;
      `}
    }
  `
)

export const DropdownDivider = styled(Dropdown.Divider)`
  margin: 8px 0;
  width: 100%;
`

export const DropdownHeader = styled(Dropdown.Header)`
  margin-left: 20px;
`

export const DropdownChevrons = styled(Dropdown.Chevrons)`
  margin-left: 8px;
  flex-shrink: 0;
`

const SsoBadge = styled.span(
  ({ theme }) => css`
    margin-left: 8px;
    line-height: 1.25;
    font-size: ${theme.fontSizes.little};
    font-weight: ${theme.fontWeights.regular};

    a:not(.active) > & {
      color: ${theme.colors.foreground.secondary[4]};
    }
  `
)

interface ExpiredProps {
  $expired?: boolean
}

const Label = styled(Caption)<ExpiredProps>`
  ${({ expired, theme }) => css`
    font-size: ${theme.fontSizes.little};
    text-align: end;
    color: unset;
    opacity: ${expired ? '1' : '0.45'};
    margin: 0 0 0 8px;

    a:not(.active) > & {
      color: ${theme.colors.foreground.secondary[4]};
    }
  `}
`

export const SsoTag = () => <SsoBadge>SSO</SsoBadge>
export const ExpiredLabel = () => <Label expired={true}>Expired</Label>

export const SignedOutLabel = ({
  expired,
  className,
}: {
  expired: boolean
  className?: string
}) => (
  <Label className={className} expired={expired}>
    Signed out
  </Label>
)

export const DropdownLinkItem = styled(Dropdown.Item.NavLink)<ExpiredProps>`
  user-select: none;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  opacity: ${({ $expired }) => ($expired ? '0.45' : '1')};
`

export const DrodpwonItemSubtitle = styled.div(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.little};
    color: ${theme.colors.foreground.secondary[4]};
  `
)
